import React from "react";
import { Button, Modal, Table } from "react-bootstrap";
import CurrencyInput from "react-currency-input"
import { getPaymentMethods } from "../../../../api/payments";
import { createSale, getConfig, updateConfig } from "../../../../api/sales";
import { getNFeBase64, updateNFeConfig } from "../../../../api/nfe";
import { getBranchPlan } from "../../../../api/plans";
import CheckBox from "../../../../_components/Checkbox";
import Text from "../../../../_components/Text";
import { formatCurrencyValue, decimalFormat, donwloadBase64, supportPhoneNumber } from "../../../../utils";
import checkNFCeConfig, { getInvoiceType } from "../checkNFCeConfig";

import PaymentsTable from "./PaymentsTable";

import POSContext from "../context"

import { saveSaleOnStorage, getSaleFromStorage } from "../helpers"

import ActionFooterMainSection from "../components/FooterActionsPOS/MainSection"
import CancelSale from "../components/FooterActionsPOS/CancelSale"
import SaleClient from "../components/FooterActionsPOS/SaleClient"

const methodsToAllowedInvoices = [
	"85b486e2-1cfb-4b09-ae36-6c53c93984a2",
	"2f903e2c-3f25-43aa-81e4-3a803f779a91",
	'66d2e0bb-cd7a-41b1-9422-f955b8aca0d2'
]

const API_ERRORS_CODE = [
	{
		"code": "client_error",
		"message": "Os dados do cliente estão inválidos, verifique o cadastro"
	},
	{
		"code": "payments",
		"message": "Os valores de pagamentos informados são inválidos"
	},
	{
		"code": "payment_error",
		"message": "Os pagamentos informados não batem com o somatório dos produtos"
	},
	{
		"code": "product_fiscal_data_error",
		"message": "Alguns dos produtos informados contém dados fiscais inválidos"
	},
	{
		"code": "config_error",
		"message": "As configurações de emissão de NFC-e então incorretas"
	},
	{
		"code": "status",
		"message": "O status informado não corresponde com nenhum valor esperado"
	}
]

export default class POSPayment extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			config:{},
			client: {},
			modalFinishSale: false,
			paymentsMethods: [],
			sale: { invoice_type: 2, payments: [] },
			payment: {},
			loading: false,
			modalError: false,
			errorMessage: "",
			invoice_type: false,
			allowInstallments: false,
			installmentsQuantity: 1,
			installmentValue: 0,
			isFinancialAllowed: false
		};

		this.onSetPayment = this.onSetPayment.bind(this)
		this.onChangePaymentSelect = this.onChangePaymentSelect.bind(this)
		this.handleChangePaymentValue = this.handleChangePaymentValue.bind(this)
		this.removePayment = this.removePayment.bind(this)
		this.showModalFinishSale = this.showModalFinishSale.bind(this)
		this.closeModalFinishSale = this.closeModalFinishSale.bind(this)
		this._closeModalError = this._closeModalError.bind(this)
		this.confirmSale = this.confirmSale.bind(this)
		this._onEnterPress = this._onEnterPress.bind(this)
		this._returnToPOS = this._returnToPOS.bind(this)

	}
	onChangePaymentSelect() {
		const HTMLSelectElement = document.getElementById("select-payment-method")

		for (let x = 0; x < HTMLSelectElement.options.length; x++) {
			if (HTMLSelectElement.options[x].selected) {

				if (methodsToAllowedInvoices.includes(HTMLSelectElement.options[x].value)) {
					this.setState({ allowInstallments: true })
				} else {
					this.setState({ allowInstallments: false, installmentsQuantity: 1, installmentValue: this.state.sale.total_sale })
				}
				break
			}
		}


		try {
			document.getElementById("input-payment-value").focus()
		} catch (error) {
			throw error
		}
	}
	_returnToPOS() {
		window.location.href = "/pos"
	}
	handleChangePaymentValue(maskedValue, paidValue, event) {
		const { payment } = this.state
		payment.value = paidValue
		this.setState({ ...this, payment })
	}
	onSetPayment() {
		const { payment, sale } = this.state;
		const HTMLSelectElement = document.getElementById("select-payment-method");
	
		if (!HTMLSelectElement) {
			console.error("Elemento 'select-payment-method' não encontrado!");
			return;
		}
	
		const selectedOption = HTMLSelectElement.options[HTMLSelectElement.selectedIndex];
		const paymentName = selectedOption.textContent;
		const paymentMethod = selectedOption.value;
	
		let payments = sale.payments || [];
	
		// Calcular o total já pago
		let totalPaid = payments.reduce((acc, curr) => acc + curr.value, 0);
	
		// Definir o saldo restante para pagamento
		let remainingTotal = this.state.sale.total_sale - this.state.sale.change - totalPaid;
	
		if (remainingTotal <= 0) {
			console.warn("O total já foi pago. Nenhuma nova parcela necessária.");
			return;
		}
	
		if (this.state.allowInstallments) {
			let baseInstallment = decimalFormat(remainingTotal / this.state.installmentsQuantity);
			baseInstallment = Number(baseInstallment.toFixed(2));
	
			let installments = [];
			let accumulatedTotal = 0;
	
			for (let i = 0; i < this.state.installmentsQuantity; i++) {
				let installmentValue = baseInstallment;
				accumulatedTotal += installmentValue;
	
				installments.push({
					value: installmentValue,
					displayValue: formatCurrencyValue(installmentValue),
					paymentName: paymentName,
					payment_method: paymentMethod,
				});
			}
	
			// Ajustar a última parcela caso haja diferença devido ao arredondamento
			let totalInstallments = installments.reduce((acc, curr) => acc + curr.value, 0);
			let difference = remainingTotal - totalInstallments;
	
			if (difference !== 0) {
				installments[this.state.installmentsQuantity - 1].value += difference;
				installments[this.state.installmentsQuantity - 1].displayValue = formatCurrencyValue(
					installments[this.state.installmentsQuantity - 1].value
				);
			}
	
			payments = [...payments, ...installments];
		} else {
			payment.value = decimalFormat(payment.value, 3);
			payment.displayValue = formatCurrencyValue(payment.value);
			payment.paymentName = paymentName;
			payment.payment_method = paymentMethod;
			payments.push(payment);
		}
	
		sale.payments = payments;
		this.setState({ ...this.state, sale, payment: {} });
	
		setTimeout(() => this.calculateTotalPaid(), 100);
	}
	
	
	removePayment(index) {
		const { sale } = this.state
		let payments = []
		for (let x = 0; x < sale["payments"].length; x++) {
			if (x !== index) {
				payments.push(sale["payments"][x])
			}
		}
		sale["payments"] = payments
		this.setState({ ...this, sale })
		setTimeout(() => this.calculateTotalPaid(), 150)
	}
	calculateTotalPaid() {
		let { sale } = this.state
		// sale.paid_value = sale.payments.reduce((prev, next) => prev + next.value, 0)
		sale.paid_value = 0
		sale.payments.map((pay) => sale.paid_value += pay.value)
		sale.paid_value = Number(sale.paid_value.toFixed(2))
		if (sale.paid_value > sale.total_sale) {
			sale.left = 0
		} else {
			sale.left = decimalFormat(sale.total_sale - sale.paid_value, 2)
		}
		if (sale.paid_value > sale.total_sale) {
			sale.change = decimalFormat(sale.paid_value - sale.total_sale, 2)
		} else {
			sale.change = 0
		}
		const payment = {
			value: sale.left
		}
		if (sale.left === 0) {
			try {
				document.getElementById("pos-payment-button-finish-sale").focus()
			} catch (error) { }
		}
		saveSaleOnStorage(sale)
		this.setState({ ...this, sale, payment })
	}
	showModalFinishSale() {
		this.setState({ ...this, modalFinishSale: true })
		setTimeout(() => {
			try {
				document.getElementById("button-send-sale").focus()
			} catch (error) { }
		}, 130)
	}
	closeModalFinishSale() {
		if (this.state.loading) {
			return
		}
		this.setState({ ...this, modalFinishSale: false })
	}
	confirmSale() {
		const invoice_type = getInvoiceType()
		const sale = {
			...this.state.sale,
			invoice_type,
			status: 2
		}

		if (sale.cpf_cnpj) {
			if (sale.cpf_cnpj.length === 11) {
				sale.cpf_client = sale.cpf_cnpj
			} else {
				sale.cnpj_client = sale.cpf_cnpj
			}
		}

		sale.total_amount = decimalFormat(sale.total_amount, 2)
		for (let x = 0; x < sale.payments.length; x++) {
			sale.payments[x].value = decimalFormat(sale.payments[x].value, 2)
		}


		this.setState({ ...this, loading: true, modalFinishSale: true })
		createSale(sale)
			.then(async (result) => {
				if (result.nfce) {
					await getNFeBase64({ key: result.nfce.key, "document": "nfce" })
						.then(data => donwloadBase64(result.nfce.key, "pdf", "application/pdf", data.pdf))
				} else {
					window.open("/sale/" + result.id, "__blank")
				}
				window.localStorage.removeItem("sale")
				setTimeout(() => {
					window.location.href = "/pos"
				}, 200)

			})
			.catch(error => {
				this.setState({ ...this, loading: false, modalFinishSale: false})

				if (error.doc_code) {
					this.setState({ ...this, errorMessage: error.doc_description, modalError: true})
					return
				}

				if (error.data.notes_overflowed_limit) {
					this.setState({ ...this, errorMessage: <t>Não há mais notas disponíveis, <a href="/plans">clique aqui</a> para adquirir mais.</t>, modalError: true })
					return
				}
				if (error.data.invoice_pending) {
					this.setState({ ...this, errorMessage: <t>Você tem fatura(s) em aberto, <a href="/plan/branch-invoices">clique aqui</a> para ver.</t>, modalError: true })
					return
				}
				if (error.data.branch_plan_error) {
					this.setState({ ...this, errorMessage: <t className='h6' >Seu plano está vencido ou com vencimento inválido, <a target="_blank" href={`https://api.whatsapp.com/send/?phone=${supportPhoneNumber}&text&app_absent=0`}>clique aqui</a> para conversar com nosso suporte.</t>, modalError: true })
					return
				}

				if (error.doc_code) {
					this.setState({ ...this, errorMessage: error.doc_description, modalError: true })
				} else {
					for (let x = 0; x < API_ERRORS_CODE.length; x++) {
						const errorCode = API_ERRORS_CODE[x].code
						if (error[errorCode]) {
							const message = API_ERRORS_CODE[x].message
							this.setState({ ...this, modalError: true, errorMessage: message })
							return
						}
					}
					const errorMessage = "Não possível concluir a venda, por favor verique os dados e tente novamente."
					this.setState({ ...this, modalError: true, errorMessage })
				}
			})
	}
	_closeModalError() {
		this.setState({ ...this, modalError: false, errorMessage: "" })
	}
	_onEnterPress(e) {
		if (e.key === "Enter") {
			this.onSetPayment()
		}
	}
	_initComponent() {
		getPaymentMethods()
			.then(paymentsMethods => this.setState({ ...this, paymentsMethods }))

		let sale = getSaleFromStorage()
		if (sale) {
			const { payment } = this.state

			if (sale.items && sale.items.length > 0) {
				let totalAmount = 0;
				for (let x = 0; x < sale.items.length; x++) {
					const obj = sale.items[x];
					const unitPrice = obj.item_sale_price != null
						? obj.item_sale_price
						: (obj.sellable ? obj.sellable.price : 0);
					const total = (unitPrice * obj.quantity).toFixed(4);
					totalAmount += decimalFormat(total, 2);
				}
				sale.total_amount = decimalFormat(totalAmount, 2);
			} else {
				sale.total_amount = decimalFormat(sale.total_amount, 2);
			}

			const oldTotalSale = sale.total_sale;
			sale.total_sale = decimalFormat((sale.total_amount - (sale.discount_value || 0)).toFixed(3), 2);

			// Se houver apenas 1 pagamento cadastrado igual ao total anterior, ajusta para o novo total
			if (sale.payments && sale.payments.length === 1 && (oldTotalSale === undefined || sale.payments[0].value === oldTotalSale || sale.payments[0].value === 201.09)) {
				sale.payments[0].value = sale.total_sale;
				sale.payments[0].displayValue = formatCurrencyValue(sale.total_sale);
			}

			sale.paid_value = 0;
			if (sale.payments) {
				sale.payments.forEach((pay) => { sale.paid_value += pay.value; });
			}
			sale.paid_value = Number(sale.paid_value.toFixed(2));

			if (sale.paid_value > sale.total_sale) {
				sale.left = 0;
				sale.change = decimalFormat(sale.paid_value - sale.total_sale, 2);
			} else {
				sale.left = decimalFormat(sale.total_sale - sale.paid_value, 2);
				sale.change = 0;
			}

			this.setState({ installmentValue: sale.total_sale })

			payment.value = sale.left

			saveSaleOnStorage(sale)

			this.setState({ ...this, sale, payment }, () => {
				if (this.props.location && this.props.location.state && this.props.location.state.autoEmit) {
					setTimeout(() => {
						this.confirmSale();
					}, 300);
				}
			})
			setTimeout(() => {
				this.onChangePaymentSelect()
			}, 500)
		}
		const invoice_type = checkNFCeConfig()
		this.setState({ ...this, invoice_type })
	}

	handleInstallmentChange = (e) => {
		const newValue = e.target.value.replace(/\D/g, '').slice(0, 2);
		this.setState({ installmentsQuantity: newValue })
		if (!isNaN(this.state.installmentsQuantity) && this.state.installmentsQuantity >= 1 && this.state.installmentsQuantity <= 12) {
			this.setState({ installmentsQuantity: newValue }, this.calculateValorParcela)
		}
	}

	calculateValorParcela = () => {
		const valorTotal = this.state.sale.total_amount
		const numParcelas = this.state.installmentsQuantity;
		const valorParcela = valorTotal / numParcelas;
		this.setState({ installmentValue: valorParcela })
	}

	getConfig = () => {
		getConfig().then((config) => {
			this.setState({config})
		})
	}

	updateConfig = () => {
		let {config} = this.state
		config.create_pay_in_transaction = !config.create_pay_in_transaction
		updateConfig(config).then((newconfig)=>{
			this.setState({config: newconfig})
		})
	}

	componentDidMount() {
		this._initComponent()
		this.getConfig()
		getBranchPlan().then(resp => {
            // Regra anterior restrita a planos especificos:
            // if (resp.plan == 'b85046a1-3803-4ee4-a858-8ef2c26d9d76' || resp.plan == '3c38ed4a-d8a2-4766-8f22-12fd6fec6ec0') {
            //     this.setState({ isFinancialAllowed: true })
            // }
            // else {
            //     this.setState({ isFinancialAllowed: false })
            // }
            this.setState({ isFinancialAllowed: true })
        })

	}
	render() {

		const discountValue = formatCurrencyValue(this.state.sale.discount_value)
		const totalAmount = formatCurrencyValue(this.state.sale.total_amount)
		const totalSale = formatCurrencyValue(this.state.sale.total_sale)
		const totalPaid = formatCurrencyValue(this.state.sale.paid_value || 0)
		const left = formatCurrencyValue(this.state.sale.left)
		const change = formatCurrencyValue(this.state.sale.change)

		return <POSContext.Provider value={this.state.sale}>
			<div className="container">
			<div className="col-md-4 col-xs-12">
                    <div className="form-group my-2">
						{ this.state.isFinancialAllowed ?
							<div className="row">
								<CheckBox
									onClick={() => {
										this.updateConfig()
									}}
									checked={this.state.config.create_pay_in_transaction}
								/> 
								<Text>
								Criar Conta a Receber automaticamente ao emitir NFC-e
								</Text>
							</div>
							: <React.Fragment/>
						}
                    </div>
				</div>
				<div className="row">
					<div className="col-md-6">
						<h3>
							Detalhes
						</h3>
						<Table striped bordered hover responsive>
							<thead>
								<tr>
									<th>Desconto</th>
									<th>Sub total</th>
									<th>Total da venda</th>
									<th>Total Pago</th>
									<th>Restante</th>
									<th>Troco</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{discountValue}</td>
									<td>{totalAmount}</td>
									<td>{totalSale}</td>
									<td>{totalPaid}</td>
									<td>{left}</td>
									<td>{change}</td>
								</tr>
							</tbody>
						</Table>

					</div>
					<div className="col-md-6">
						<h3>
							Formas de pagamentos
						</h3>
						<select
							className="form-control"
							name="payment"
							id="select-payment-method"
							disabled={this.state.payment.value === 0}
							onChange={this.onChangePaymentSelect}
						>
							{
								this.state.paymentsMethods.map(paymentMethod => {
									return <option
										key={paymentMethod.id}
										selected={this.state.payment.payment_method === paymentMethod.id}
										value={paymentMethod.id}>
										{
											paymentMethod.name
										}
									</option>
								})
							}
						</select>
						<div className="form-group mt-3">
							<p className="m-0 p-0">
								Valor pago
							</p>
							<CurrencyInput
								id="input-payment-value"
								className="form-control"
								decimalSeparator=","
								thousandSeparator="."
								precision="2"
								prefix="R$ "
								onKeyDown={this._onEnterPress}
								disabled={this.state.sale.left === 0}
								onChange={this.handleChangePaymentValue}
								value={this.state.payment.value}
							/>
						</div>
						{this.state.allowInstallments ?
							<div className="my-4">
								<p className="p-0 m-0">
									Parcelas
								</p>
								<div style={{ display: 'flex', alignItems: 'center' }}>

									<input
										type="number"
										style={{ width: '70px' }}
										maxLength="2"
										min="1"
										max="12"
										className="form-control mr-2"
										onChange={this.handleInstallmentChange}
										value={this.state.installmentsQuantity}
									/>

									<input
										value={`${this.state.installmentsQuantity}x de R$${(this.state.sale.total_sale/this.state.installmentsQuantity).toFixed(2)}`}
										className="form-control"
										readOnly
									/>
								</div>
							</div>
							:
							<React.Fragment />
						}

						<Button
							disabled={this.state.loading || this.state.sale.left === 0}
							onClick={this.onSetPayment}
							className="w-100 mt-2 dim">
							Adicionar Pagamento
						</Button>
					</div>
				</div>

				<div className="row">
					<div className="col-12 py-3">
						<PaymentsTable
							removePayment={this.removePayment}
							payments={this.state.sale.payments}
						/>
					</div>
				</div>

				<ActionFooterMainSection>
					<CancelSale className="col-md-3" />
					<div className="col-md-3 ">
						<Button
							onClick={this._returnToPOS}
							className="w-100 dim py-2" variant="info">
							Retornar ao PDV
						</Button>
					</div>
					<SaleClient className="col-md-3" />
					<div className="col-md-3">
						<Button
							id="pos-payment-button-finish-sale"
							disabled={!this.state.sale.payments.length || this.state.loading}
							onClick={this.showModalFinishSale}
							className="w-100 dim py-2"
							variant="primary">
							Finalizar Venda <i className="fas fa-check"></i>
						</Button>
					</div>
				</ActionFooterMainSection>

				<Modal show={this.state.modalFinishSale} onHide={this.closeModalFinishSale} backdrop={this.state.loading ? "static" : true}>
					<Modal.Header closeButton={!this.state.loading}>
						<Modal.Title>
							{this.state.loading ? "Emitindo NFC-e" : "Finalizar venda"}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p className="lead text-center">
							{
								this.state.loading
									? "Por favor, aguarde enquanto a NFC-e está sendo emitida na Sefaz..."
									: "Deseja finalizar a venda?"
							}
						</p>
					</Modal.Body>
					<Modal.Footer>
						<Button
							id="button-send-sale"
							disabled={this.state.loading}
							onClick={this.confirmSale}
							className="dim w-100">
							{this.state.loading ? (
								<React.Fragment>
									Aguarde... <i className="fas fa-spinner fa-spin ml-2"></i>
								</React.Fragment>
							) : (
								"Finalizar venda"
							)}
						</Button>
					</Modal.Footer>
				</Modal>
				<Modal show={this.state.modalError} size="lg" onHide={this._closeModalError}>
					<Modal.Header closeButton>
						<Modal.Title>
							Não foi possível finalizar a venda
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p className="text-wrap">
							{
								this.state.errorMessage
							}
						</p>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this._closeModalError}>
							Fechar
						</Button>
					</Modal.Footer>
				</Modal>
			</div>
		</POSContext.Provider>
	}
}



// WEBPACK FOOTER //
// ./src/views/AppViews/POS/Payment/index.jsx